import React from 'react';
import { ImageFadeIn } from '../components/animations/ImageFadeIn';
import { ScrollReveal } from '../components/animations/ScrollReveal';
import { CheckCircle, Clock, Users, Heart, Shield, Target, Building, Zap } from 'lucide-react';
const RoadmapPage = () => {
  return <div className="w-full min-h-screen bg-white" data-id="element-709">
      {/* Hero Section */}
      <div className="relative min-h-[60vh] flex items-center" data-id="element-710">
        <div className="absolute inset-0 z-0" data-id="element-711">
          <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/nSwuHbb12i4azWUVYSdDyT/960x0.webp" alt="Jerusalem Old City with Dome of the Rock at sunset" className="w-full h-full object-cover" data-id="element-712" />
          <div className="absolute inset-0 bg-black/50" data-id="element-713"></div>
        </div>
        <div className="relative z-10 w-full pt-36 sm:pt-52 md:pt-56 pb-16 sm:pb-20" data-id="element-714">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center" data-id="element-715">
            <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold text-white tracking-tight mb-4 sm:mb-6" data-id="element-716">
              Implementation Timeline
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl text-white/90 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-717">
              Building a nationwide shield of civilian resilience through
              comprehensive training
            </p>
          </div>
        </div>
      </div>
      {/* Vision Statement */}
      <ScrollReveal animation="fade" data-id="element-718">
        <div className="py-16 sm:py-24 bg-white" data-id="element-719">
          <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-720">
            <div className="text-center mb-8" data-id="element-721">
              <div className="inline-flex items-center justify-center mb-6" data-id="element-722">
                <Heart className="w-8 h-8 text-red-500 mr-3" data-id="element-723" />
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-724">
                  Our Vision
                </h2>
              </div>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-725">
                Establishing Regional Civilian Training Centers across Israel
              </p>
            </div>
            <div className="prose prose-lg max-w-none text-gray-700 mb-6" data-id="element-726">
              <p data-id="element-727">
                Families are currently being trained in Samaria as we work
                towards construction of the Samaria Regional Training Center
                (SRTC). The Samaria Regional Training Center (SRTC) will serve
                as a permanent hub for civilian security and emergency response
                training, offering free to low cost instruction to Israeli
                civilians. No comparable center currently exists in Israel, and
                the development of this facility will establish an ongoing,
                powerful, and sustained capability to ensure the local
                population is fully prepared for all types of crisis situations.
                Our goal is to train at least 50,000 civilians per year, with 7
                full-time Israeli staff members and experienced instructors
                ensuring that Israeli communities receive proactive training in
                addressing emerging security threats.
              </p>
            </div>
            <ScrollReveal animation="scale" delay={0.2} data-id="element-728">
              <div className="relative mt-10 mb-8" data-id="element-729">
                <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/iJxhKShBKb1wywLqvcgR3s/israel-flag-masada-1024x683.jpg" alt="Israeli flag flying over Masada with Dead Sea view" className="w-full h-auto rounded-xl shadow-lg" data-id="element-730" />
              </div>
            </ScrollReveal>
          </div>
        </div>
      </ScrollReveal>
      {/* Current Phase - Highlighted */}
      <ScrollReveal animation="fade" data-id="element-731">
        <div className="py-16 sm:py-24 bg-blue-50" data-id="element-732">
          <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-733">
            <div className="text-center mb-16" data-id="element-734">
              <div className="inline-flex items-center justify-center mb-6" data-id="element-735">
                <Zap className="w-8 h-8 text-blue-500 mr-3" data-id="element-736" />
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-737">
                  Where We Are Today
                </h2>
              </div>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-738">
                Immediate action while building for the future
              </p>
            </div>
            <ScrollReveal animation="slide-up" data-id="element-739">
              <div className="bg-white p-8 sm:p-10 rounded-xl shadow-sm border border-gray-100 mb-12 relative overflow-hidden" data-id="element-740">
                <div className="absolute top-0 right-0 bg-green-100 text-green-800 px-4 py-2 rounded-bl-lg font-medium text-sm" data-id="element-741">
                  In Progress
                </div>
                <div className="flex items-start gap-6" data-id="element-742">
                  <div className="hidden sm:block flex-shrink-0" data-id="element-743">
                    <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-744">
                      <Clock className="w-8 h-8 text-blue-600" data-id="element-745" />
                    </div>
                  </div>
                  <div data-id="element-746">
                    <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-747">
                      Phase 1: Approval & Funding (Months 1-6)
                    </h3>
                    <div className="prose prose-lg text-gray-700" data-id="element-748">
                      <p data-id="element-749">
                        While we secure final approvals and begin construction
                        on the permanent training center, we're already bringing
                        critical training to the communities that need it most.
                      </p>
                    </div>
                    <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-750">
                      <ScrollReveal animation="slide-left" delay={0.1} data-id="element-751">
                        <div className="bg-blue-50 p-6 rounded-lg" data-id="element-752">
                          <h4 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-753">
                            Immediate Community Training
                          </h4>
                          <ul className="space-y-3" data-id="element-754">
                            <li className="flex items-start" data-id="element-755">
                              <Clock className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-756" />
                              <span className="text-gray-700" data-id="element-757">
                                Secure $750,000 in U.S. donor and partner
                                funding to enhance current training underway in
                                regional areas.
                              </span>
                            </li>
                            <li className="flex items-start" data-id="element-758">
                              <Clock className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-759" />
                              <span className="text-gray-700" data-id="element-760">
                                Deploy portable 2 additional portable MILO Range
                                simulators to high-risk communities and add 2
                                additional Israeli trainers
                              </span>
                            </li>
                            <li className="flex items-start" data-id="element-761">
                              <Clock className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-762" />
                              <span className="text-gray-700" data-id="element-763">
                                Develop realistic community-based training in
                                emergency medical care and weapons
                                familiarization
                              </span>
                            </li>
                          </ul>
                        </div>
                      </ScrollReveal>
                      <ScrollReveal animation="slide-right" delay={0.1} data-id="element-764">
                        <div className="bg-blue-50 p-6 rounded-lg" data-id="element-765">
                          <h4 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-766">
                            Site Development
                          </h4>
                          <ul className="space-y-3" data-id="element-767">
                            <li className="flex items-start" data-id="element-768">
                              <CheckCircle className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-769" />
                              <span className="text-gray-700" data-id="element-770">
                                Land has been zoned and approved for the center
                              </span>
                            </li>
                            <li className="flex items-start" data-id="element-771">
                              <Clock className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-772" />
                              <span className="text-gray-700" data-id="element-773">
                                Infrastructure planning underway with approved
                                zoning
                              </span>
                            </li>
                            <li className="flex items-start" data-id="element-774">
                              <Clock className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-775" />
                              <span className="text-gray-700" data-id="element-776">
                                Begin immediate construction of two civilian
                                dedicated live fire ranges
                              </span>
                            </li>
                          </ul>
                        </div>
                      </ScrollReveal>
                    </div>
                  </div>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </ScrollReveal>
      {/* The Journey Ahead */}
      <ScrollReveal animation="fade" data-id="element-777">
        <div className="py-16 sm:py-24 bg-white" data-id="element-778">
          <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-779">
            <div className="text-center mb-16" data-id="element-780">
              <div className="inline-flex items-center justify-center mb-6" data-id="element-781">
                <Target className="w-8 h-8 text-blue-500 mr-3" data-id="element-782" />
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-783">
                  The Journey Ahead
                </h2>
              </div>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-784">
                Our path to building nationwide civilian resilience
              </p>
            </div>
            <div className="space-y-16" data-id="element-785">
              {/* Phase 2 */}
              <ScrollReveal animation="slide-up" data-id="element-786">
                <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-787">
                  <div className="w-full md:w-2/5" data-id="element-788">
                    <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/3emtZQ7VsFWHjTbEYziWS7/cpr_training.jpg" alt="Training center construction" className="w-full h-auto rounded-lg shadow-lg" data-id="element-789" />
                  </div>
                  <div className="w-full md:w-3/5" data-id="element-790">
                    <div className="flex items-center mb-4" data-id="element-791">
                      <Building className="w-7 h-7 text-blue-500 mr-3" data-id="element-792" />
                      <h3 className="text-2xl font-bold text-gray-900" data-id="element-793">
                        Phase 2: Site Development & Construction
                      </h3>
                    </div>
                    <p className="text-gray-500 mb-4" data-id="element-794">Months 1-12</p>
                    <div className="prose prose-lg text-gray-700" data-id="element-795">
                      <p data-id="element-796">
                        As construction progresses, we'll complete all training
                        facilities and prepare for full-scale operations. This
                        includes:
                      </p>
                      <ul data-id="element-797">
                        <li data-id="element-798">
                          - Construct 20,000 SF classroom building with 3 MILO
                          Range simulators
                        </li>
                        <li data-id="element-799">
                          - Build 25-bed dormitory (10 rooms with 2 beds; 5
                          rooms with queen beds for couples)
                        </li>
                        <li data-id="element-800">
                          - Create full-service dining hall with capacity for
                          150 people
                        </li>
                        <li data-id="element-801">
                          - Develop tactical training town with integrated
                          training roadways
                        </li>
                        <li data-id="element-802">
                          - Establish administrative offices and security hubs
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
              {/* Phase 3 */}
              <ScrollReveal animation="slide-up" data-id="element-803">
                <div className="flex flex-col md:flex-row-reverse gap-8 items-center" data-id="element-804">
                  <div className="w-full md:w-2/5" data-id="element-805">
                    <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/fgT2UYSUqZLvWeymTwzsmW/Screenshot_2025-06-06_at_5.11.03_PM.png" alt="Instructor training session" className="w-full h-auto rounded-lg shadow-lg" data-id="element-806" />
                  </div>
                  <div className="w-full md:w-3/5" data-id="element-807">
                    <div className="flex items-center mb-4" data-id="element-808">
                      <Users className="w-7 h-7 text-blue-500 mr-3" data-id="element-809" />
                      <h3 className="text-2xl font-bold text-gray-900" data-id="element-810">
                        Phase 3: Curriculum Development & Instructor Training
                      </h3>
                    </div>
                    <p className="text-gray-500 mb-4" data-id="element-811">Months 9-12</p>
                    <div className="prose prose-lg text-gray-700" data-id="element-812">
                      <p data-id="element-813">
                        With facilities nearing completion, we'll focus on
                        developing comprehensive training programs and preparing
                        our instructor teams:
                      </p>
                      <ul data-id="element-814">
                        <li data-id="element-815">
                          - Develop comprehensive training programs in
                          collaboration with security experts
                        </li>
                        <li data-id="element-816">
                          - Curriculum will be developed in coordination with
                          Israeli doctrine and training standards
                        </li>
                        <li data-id="element-817">
                          - Train core Israeli instructor teams with a civilian
                          focus
                        </li>
                        <li data-id="element-818">
                          - Conduct pilot training sessions with evaluation
                          metrics
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
              {/* Phase 4 */}
              <ScrollReveal animation="slide-up" data-id="element-819">
                <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-820">
                  <div className="w-full md:w-2/5" data-id="element-821">
                    <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/kvcVKww79qLwCwtTvbHoss/%D7%A6%D7%99%D7%9C%D7%95%D7%9D-%D7%99%D7%97%D7%99%D7%90%D7%9C-%D7%92%D7%95%D7%A8%D7%A4%D7%99%D7%99%D7%9F-127-1024x683.jpg" alt="Full operational training" className="w-full h-auto rounded-lg shadow-lg" data-id="element-822" />
                  </div>
                  <div className="w-full md:w-3/5" data-id="element-823">
                    <div className="flex items-center mb-4" data-id="element-824">
                      <Shield className="w-7 h-7 text-blue-500 mr-3" data-id="element-825" />
                      <h3 className="text-2xl font-bold text-gray-900" data-id="element-826">
                        Phase 4: Operational Launch & Training Programs
                      </h3>
                    </div>
                    <p className="text-gray-500 mb-4" data-id="element-827">Month 12 onward</p>
                    <div className="prose prose-lg text-gray-700" data-id="element-828">
                      <p data-id="element-829">
                        The Samaria Regional Training Center will launch
                        full-scale operations, becoming a hub for civilian
                        resilience:
                      </p>
                      <ul data-id="element-830">
                        <li data-id="element-831">- Full Samaria Civilian Training Center launch</li>
                        <li data-id="element-832">
                          - Begin structured training sessions with follow-on
                          assessment frameworks
                        </li>
                        <li data-id="element-833">- Implement clear training performance metrics</li>
                        <li data-id="element-834"> - Train 50,000 civilians and families annually</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
              {/* Phase 5 */}
              <ScrollReveal animation="slide-up" data-id="element-835">
                <div className="flex flex-col md:flex-row-reverse gap-8 items-center" data-id="element-836">
                  <div className="w-full md:w-2/5" data-id="element-837">
                    <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/jop9zBgRujeWdeTtyMQTQf/Screenshot_2025-06-06_at_5.11.07_PM.png" alt="Nationwide expansion" className="w-full h-auto rounded-lg shadow-lg" data-id="element-838" />
                  </div>
                  <div className="w-full md:w-3/5" data-id="element-839">
                    <div className="flex items-center mb-4" data-id="element-840">
                      <Target className="w-7 h-7 text-blue-500 mr-3" data-id="element-841" />
                      <h3 className="text-2xl font-bold text-gray-900" data-id="element-842">
                        Phase 5: Expansion & Sustainability
                      </h3>
                    </div>
                    <p className="text-gray-500 mb-4" data-id="element-843">Year 2 and beyond</p>
                    <div className="prose prose-lg text-gray-700" data-id="element-844">
                      <p data-id="element-845">
                        With the Samaria center established, we'll begin
                        expanding our impact across Israel:
                      </p>
                      <ul data-id="element-846">
                        <li data-id="element-847">
                          - Evaluate potential additional training centers in
                          high-risk regions (Judea and Galilee)
                        </li>
                        <li data-id="element-848">
                          - Expand partnership networks for sustained financial
                          backing and funding
                        </li>
                        <li data-id="element-849">
                          - Establish mobile training units for broader reach
                          into remote communities
                        </li>
                        <li data-id="element-850">
                          {' '}
                          - Develop long-term financial sustainability plan
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </div>
      </ScrollReveal>
      {/* Funding Needs */}
      <ScrollReveal animation="fade" data-id="element-851">
        <div className="py-16 sm:py-24 bg-gray-50" data-id="element-852">
          <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-853">
            <div className="text-center mb-16" data-id="element-854">
              <div className="inline-flex items-center justify-center mb-6" data-id="element-855">
                <Heart className="w-8 h-8 text-red-500 mr-3" data-id="element-856" />
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-857">
                  Funding Needs
                </h2>
              </div>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-858">
                Supporting the implementation of this critical initiative
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-859">
              <ScrollReveal animation="slide-left" delay={0.1} data-id="element-860">
                <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 relative overflow-hidden" data-id="element-861">
                  <div className="absolute top-0 right-0 w-32 h-32 -mt-10 -mr-10 bg-blue-50 rounded-full opacity-50" data-id="element-862"></div>
                  <div className="relative" data-id="element-863">
                    <div className="flex items-center mb-6" data-id="element-864">
                      <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mr-4" data-id="element-865">
                        <Users className="w-6 h-6 text-blue-600" data-id="element-866" />
                      </div>
                      <div data-id="element-867">
                        <div className="text-xl font-bold text-gray-900" data-id="element-868">
                          Initial Funding
                        </div>
                        <div className="text-sm text-gray-500" data-id="element-869">$750,000</div>
                      </div>
                    </div>
                    <div className="prose prose-lg text-gray-700" data-id="element-870">
                      <p data-id="element-871">
                        - Continue additional funding to continue immediate
                        regional community-based training in Samaria and Judea,
                        including:
                      </p>
                      <ul data-id="element-872">
                        <li data-id="element-873">
                          {' '}
                          - Purchase of 2 additional portable MILO Range
                          simulators
                        </li>
                        <li data-id="element-874">
                          - 2 trauma manikins, medical kits, and medical
                          supplies
                        </li>
                        <li data-id="element-875">
                          - Funding to film approximately 25 realistic scenarios
                          in the region
                        </li>
                        <li data-id="element-876">
                          - Build two weapons training ranges (one rifle and one
                          pistol) for exclusive civilian training
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
              <ScrollReveal animation="slide-right" delay={0.1} data-id="element-877">
                <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 relative overflow-hidden" data-id="element-878">
                  <div className="absolute top-0 right-0 w-32 h-32 -mt-10 -mr-10 bg-blue-50 rounded-full opacity-50" data-id="element-879"></div>
                  <div className="relative" data-id="element-880">
                    <div className="flex items-center mb-6" data-id="element-881">
                      <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mr-4" data-id="element-882">
                        <Building className="w-6 h-6 text-blue-600" data-id="element-883" />
                      </div>
                      <div data-id="element-884">
                        <div className="text-xl font-bold text-gray-900" data-id="element-885">
                          Total Project
                        </div>
                        <div className="text-sm text-gray-500" data-id="element-886">
                          $14.1 Million
                        </div>
                      </div>
                    </div>
                    <div className="prose prose-lg text-gray-700" data-id="element-887">
                      <p data-id="element-888">- Raise approximately $14.1 million to support:</p>
                      <ul data-id="element-889">
                        <li data-id="element-890">- Regional training programs</li>
                        <li data-id="element-891">- Construction of the Regional Training Center</li>
                        <li data-id="element-892">- Initial staffing and operational costs</li>
                        <li data-id="element-893">
                          - 2 additional MILO Range Systems for permanent
                          simulation training
                        </li>
                        <li data-id="element-894">
                          - Live-fire range equipment (moving targets, lighting,
                          coverings)
                        </li>
                        <li data-id="element-895">
                          - Trauma simulation and emergency medical training
                          equipment.
                        </li>
                      </ul>
                    </div>
                    <div className="mt-6 pt-6 border-t border-gray-100" data-id="element-896">
                      <div className="bg-blue-50 p-4 rounded-lg" data-id="element-897">
                        <p className="text-gray-700 font-medium" data-id="element-898">
                          Land has already been zoned and approved for the
                          center, with infrastructure planning underway and
                          formal agreements pending.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </div>
      </ScrollReveal>
      {/* Long-Term Financial Plan */}
      <ScrollReveal animation="fade" data-id="element-899">
        <div className="py-16 sm:py-24 bg-white" data-id="element-900">
          <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-901">
            <div className="text-center mb-16" data-id="element-902">
              <div className="inline-flex items-center justify-center mb-6" data-id="element-903">
                <Shield className="w-8 h-8 text-blue-500 mr-3" data-id="element-904" />
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-905">
                  Long-Term Financial Plan
                </h2>
              </div>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-906">
                Ensuring sustainability for continued impact
              </p>
            </div>
            <div className="space-y-4 mb-16" data-id="element-907">
              {[0, 1, 2, 3, 4].map(index => <ScrollReveal key={index} animation="slide-up" delay={index * 0.1} data-id="element-908">
                  <div className="bg-gray-50 p-6 rounded-lg" data-id="element-909">
                    <p className="text-gray-700" data-id="element-910">{fundingModel[index]}</p>
                  </div>
                </ScrollReveal>)}
            </div>
          </div>
        </div>
      </ScrollReveal>
      {/* Call to Action */}
      <ScrollReveal animation="fade" data-id="element-911">
        <div className="py-16 sm:py-24 bg-israel-blue text-white" data-id="element-912">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center" data-id="element-913">
            <h2 className="text-3xl sm:text-4xl font-bold mb-6 tracking-tight" data-id="element-914">
              Help Us Build This Vital Resource
            </h2>
            <p className="text-xl text-white/90 mb-10 max-w-3xl mx-auto" data-id="element-915">
              Become a part of a historic life saving effort, join us in
              protecting the civilian population of Israel.
            </p>
            <div className="flex flex-wrap justify-center gap-6" data-id="element-916">
              <a href="https://donate.stripe.com/7sY5kw7P1eO24x90y314401" target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-4 bg-white text-israel-blue font-semibold rounded-lg hover:bg-gray-100 transition-colors text-lg shadow-lg" data-id="element-917">
                Donate Now
              </a>
              <a href="/support" className="inline-block px-8 py-4 bg-transparent text-white font-semibold rounded-lg border-2 border-white hover:bg-white/10 transition-colors text-lg" data-id="element-918">
                Support Our Mission
              </a>
            </div>
          </div>
        </div>
      </ScrollReveal>
    </div>;
};
const fundingModel = ['Donor Sponsorship Programs – Establish annual and lifetime donation tiers in direct support of the training center.', 'Corporate Grants – Pursue funding from Israeli focused organizations.', 'Family Sponsorship Program – Enable donators to sponsor individual/specific family members across Israel', 'Civilian Scholarships – Civilians training scholarship programs to ensure all civilians can attend.', 'Municipal Sponsorship Program – Utilization of government grants to sponsor training.'];
export default RoadmapPage;